import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '/images/started_bck.svg'


const _hoisted_1 = { class: "relative z-10 p-8 text-center" }
const _hoisted_2 = { class: "text-2xl font-bold text-neutral-100 dark:text-primary-100 my-8" }
const _hoisted_3 = {
  key: 0,
  class: "text-neutral-200 dark:text-primary-200 mb-6 max-w-2xl mx-auto"
}

interface Props {
  title?: string;
  description?: string;
  buttonLabel?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'StartSignup',
  props: {
    title: { default: "" },
    description: { default: "" },
    buttonLabel: { default: "" }
  },
  setup(__props: any) {

const config = useRuntimeConfig();

const props = __props;

const getLabel = () => {
  if (props.buttonLabel) {
    return props.buttonLabel;
  }
  if (config.public.prelaunch) {
    return "Coming soon";
  }
  return "Sign up";
};

const links = ref([
  {
    label: getLabel(),
    to: config.public.prelaunch ? "#" : "/signup",
    icon: "i-heroicons-arrow-right",
    color: "primary" as const,
    size: "lg" as const,
    variant: "solid" as const,
  },
]);

return (_ctx: any,_cache: any) => {
  const _component_UButton = _resolveComponent("UButton")!
  const _component_UCard = _resolveComponent("UCard")!

  return (_openBlock(), _createBlock(_component_UCard, {
    ui: {
      root: 'relative overflow-hidden',
      body: 'p-0 sm:p-0',
    },
    class: "w-full my-16 bg-gradient-to-br from-group_red-300 to-purple-900 dark:from-group_red-950 dark:to-primary-900"
  }, {
    default: _withCtx(() => [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "absolute inset-0 opacity-20" }, [
        _createElementVNode("div", { class: "absolute -top-4 -right-4 w-24 h-24 bg-primary-400 rounded-full blur-2xl" }),
        _createElementVNode("div", { class: "absolute -bottom-4 -left-4 w-32 h-32 bg-primary-300 rounded-full blur-3xl" })
      ], -1)),
      _cache[1] || (_cache[1] = _createElementVNode("img", {
        src: _imports_0,
        alt: "",
        class: "absolute top-0 left-0 w-full h-full object-cover"
      }, null, -1)),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(props.title
            ? props.title
            : _unref(config).public.prelaunch
              ? "Available soon"
              : "Get started with FamilyAxis today"), 1),
        (props.description)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(props.description), 1))
          : _createCommentVNode("", true),
        _createVNode(_component_UButton, _mergeProps(_unref(links)[0], { class: "shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 bg-primary-700! text-white!" }), null, 16)
      ])
    ]),
    _: 1
  }))
}
}

})